var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartCard',{attrs:{"title":_vm.title,"wrapper_class":"pt-0"},scopedSlots:_vm._u([{key:"chart",fn:function(){return [(_vm.growthBook.mf_apex)?_c('SpilkaChartsMF',{attrs:{"height":"250","kind":"scatter","series":_vm.mfSeries}}):_c('ApexChartScatter',{attrs:{"chart-options":_vm.chartOptions,"height":"250","series":_vm.series}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }